export const ALG_APP_ID = 'K2CTT24UP3';
export const ALG_API_KEY = '2ddbb0a8db153957543d851ca677c689';
